import React from "react";
import "./PhotoWheel.css";
import { storage } from "../../firebase";
import { ref, getDownloadURL, listAll } from "firebase/storage";

function PhotographyWheel(props: { collection: string }) {
    let { collection } = props;
    [collection] = React.useState<string>(collection);

    // * Scroll
    // #region
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [isDragging, setIsDragging] = React.useState<boolean>(false);
    const [startX, setStartX] = React.useState<number | null>(null);
    const [scrollLeft, setScrollLeft] = React.useState<number>(0);
    const [currenti, setCurrenti] = React.useState<number>(0);
    const incementCurrenti = () => {
        setCurrenti(currenti + 1);
    };

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        // * Prevent dragging images
        const target = e.target as HTMLElement;
        if (target.tagName === "IMG") e.preventDefault();

        setIsDragging(true);
        setStartX(e.pageX - (containerRef.current?.offsetLeft || 0));
        setScrollLeft(containerRef.current?.scrollLeft || 0);
    };
    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!isDragging || !containerRef.current) return;
        const x = e.pageX - (containerRef.current?.offsetLeft || 0);
        const scrollX = x - (startX || 0);
        containerRef.current.scrollLeft = scrollLeft - scrollX;
    };
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    // #endregion

    // * Images
    const [imageUrls, setImageUrls] = React.useState<string[]>([]);
    React.useEffect(() => {
        const fetchImageUrls = async () => {
            try {
                const collectionRef = ref(storage, "Photography/" + collection);
                const imageList = await listAll(collectionRef);
                const imageFiles: string[] = [];
                for (let imageRef of imageList.items) {
                    imageFiles.push(await getDownloadURL(imageRef));
                }
                setImageUrls(imageFiles);
            } catch (error) {
                console.error("Error fetching image url: ", error);
            }
        };
        fetchImageUrls();
    }, []);

    return (
        <div
            className="horizontal-scroll-section"
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onScroll={(e) => {
                if (containerRef.current?.children[0].children) {
                    for (const i in containerRef.current?.children[0].children) {
                        const scrollableImage = containerRef.current?.children[0].children[i] as HTMLImageElement;
                        const imgX = scrollableImage.x;
                        const imgW = scrollableImage.width;
                        if (-imgX > imgW) {
                            setImageUrls(() => imageUrls.concat(imageUrls.slice(currenti, currenti + 1)));
                            incementCurrenti();
                        }
                    }
                }
            }}
        >
            <div className="scrollable">
                {imageUrls.map((imageUrl, index) => {
                    const image =
                        index === imageUrls.length - 1 ? (
                            <img src={imageUrl} alt={index.toString()} key={index} className="last-image" />
                        ) : (
                            <img src={imageUrl} alt={index.toString()} key={index} />
                        );
                    return image;
                })}
            </div>
        </div>
    );
}

export default PhotographyWheel;
